import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20warm%20atmosphere%20with%20soft%20golden%20amber%20and%20deep%20crimson%20gradient%2C%20film%20grain%20texture%2C%20dreamy%20bokeh%20lights%2C%20luxurious%20cinema%20aesthetic%2C%20rich%20warm%20tones%2C%20elegant%20theater%20curtain%20abstract%20pattern%2C%20soft%20focus%20background&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="90影视视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs md:text-sm tracking-widest uppercase text-accent-400 bg-accent-500/15 px-3 py-1 rounded-full mb-4">
              8090后专属影视平台
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              90影视
              <br />
              <span className="text-accent-400">
                8090影视电影电视剧大全
              </span>
            </h1>

            <p className="text-lg md:text-xl text-accent-300 font-heading mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-background-50/75 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#ranking');
                }}
                className="w-full sm:w-auto whitespace-nowrap cursor-pointer inline-flex items-center justify-center px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors text-sm"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#index');
                }}
                className="w-full sm:w-auto whitespace-nowrap cursor-pointer inline-flex items-center justify-center px-8 py-3 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors text-sm"
              >
                <i className="ri-compass-3-line mr-2"></i>
                浏览全部频道
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] shrink-0">
            <div className="relative rounded-lg overflow-hidden aspect-[4/5] md:aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20poster%20style%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20Chinese%20and%20Korean%20drama%20visual%20elements%20blended%20artistically%2C%20film%20poster%20aesthetic%2C%20dramatic%20composition%2C%20rich%20textures%2C%20elegant%20cinema%20design&width=800&height=1000&seq=hero-feature-01&orientation=portrait"
                alt="90影视精选内容合集"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex flex-wrap gap-2">
                  {['国产剧', '韩剧', '综艺', '动漫'].map((tag) => (
                    <span
                      key={tag}
                      className="text-xs bg-background-50/20 backdrop-blur-sm text-background-50 px-3 py-1 rounded-full border border-background-50/20"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}